import { SVGProps } from "react";

// Progress 0%. Dashed ring icon used by goal progress chips when there's no
// progress yet ("just kicked off"). Fill uses currentColor so the icon
// inherits the surrounding text color.
const Progress0 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      fill="currentColor"
      d="M9.56055 15.8467C9.05575 15.9465 8.5341 16 8 16C7.46557 16 6.94357 15.9466 6.43848 15.8467L6.82715 13.8857C7.20488 13.9604 7.59683 14 8 14C8.40317 14 8.79512 13.9604 9.17285 13.8857L9.56055 15.8467ZM3.00977 11.332C3.44839 11.9872 4.0128 12.5516 4.66797 12.9902L3.55469 14.6514C2.68251 14.0673 1.93157 13.3166 1.34766 12.4443L3.00977 11.332ZM14.6514 12.4443C14.0673 13.3167 13.3167 14.0673 12.4443 14.6514L11.332 12.9902C11.9872 12.5516 12.5516 11.9872 12.9902 11.332L14.6514 12.4443ZM2.11426 6.82715C2.03955 7.20488 2 7.59683 2 8C2 8.40317 2.03955 8.79512 2.11426 9.17285L0.152344 9.56055C0.0525379 9.0558 0 8.53403 0 8C0 7.46563 0.052417 6.94351 0.152344 6.43848L2.11426 6.82715ZM15.8467 6.43848C15.9466 6.94357 16 7.46557 16 8C16 8.5341 15.9465 9.05575 15.8467 9.56055L13.8857 9.17285C13.9604 8.79512 14 8.40317 14 8C14 7.59683 13.9604 7.20488 13.8857 6.82715L15.8467 6.43848ZM4.66797 3.00977C4.0128 3.44839 3.44839 4.0128 3.00977 4.66797L1.34766 3.55469C1.93161 2.68254 2.68254 1.93161 3.55469 1.34766L4.66797 3.00977ZM12.4443 1.34766C13.3166 1.93157 14.0673 2.68251 14.6514 3.55469L12.9902 4.66797C12.5516 4.0128 11.9872 3.44839 11.332 3.00977L12.4443 1.34766ZM8 0C8.53403 0 9.0558 0.0525379 9.56055 0.152344L9.17285 2.11426C8.79512 2.03955 8.40317 2 8 2C7.59683 2 7.20488 2.03955 6.82715 2.11426L6.43848 0.152344C6.94351 0.052417 7.46563 0 8 0Z"
    />
  </svg>
);

export default Progress0;
